import gql from 'graphql-tag';

export const HierarchyGradeDetails = gql`
  fragment HierarchyGradeDetails on HierarchyGrade {
    id
    grade
    album {
      id
    }
    album_folder {
      id
    }
    classes {
      total
      records {
        id
        class_name
      }
    }
  }
`;
